"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemovalRequestsPage = RemovalRequestsPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var date_fns_1 = require("date-fns");
var react_3 = require("react");
var react_router_dom_1 = require("react-router-dom");
var change_event_removal_request_1 = require("../../../features/apis/change-event-removal-request");
var hooks_1 = require("../../../store/hooks");
var STATUS_OPTIONS = [
    { key: "pending", label: "Pending" },
    { key: "approved", label: "Approved" },
    { key: "rejected", label: "Rejected" },
    { key: "all", label: "All" },
];
var ENTITY_OPTIONS = [
    { key: "all", label: "All entities" },
    { key: "tenant", label: "Tenants" },
    { key: "building", label: "Assets" },
    { key: "area", label: "Areas" },
    { key: "meter", label: "Meters" },
    { key: "service", label: "Services" },
    { key: "charge", label: "Charges" },
    { key: "invoice", label: "Invoices" },
];
var STATUS_COLOR = {
    pending: "warning",
    approved: "success",
    rejected: "danger",
};
function formatDateTime(value) {
    if (!value)
        return "—";
    try {
        return (0, date_fns_1.format)(new Date(value), "dd MMM yyyy, HH:mm");
    }
    catch (_a) {
        return value;
    }
}
function userLabel(user, fallback) {
    var _a;
    if (user)
        return (_a = ("".concat(user.firstName, " ").concat(user.lastName).trim() || user.name)) !== null && _a !== void 0 ? _a : user.email;
    return fallback !== null && fallback !== void 0 ? fallback : "—";
}
function entityLink(entityType, entityId) {
    switch (entityType) {
        case "tenant":
            return "/dashboard/tenants/".concat(entityId);
        case "building":
            return "/dashboard/assets/".concat(entityId);
        case "area":
            return "/dashboard/areas/".concat(entityId);
        case "meter":
            return "/dashboard/meters/".concat(entityId);
        case "service":
            return "/dashboard/services/".concat(entityId);
        case "charge":
            // Charges have no detail page — they're managed from inside their parent service.
            return null;
        case "invoice":
            // Invoices have no detail page — they're managed from the tenant's Invoice Settings step.
            return null;
        default:
            return null;
    }
}
var ENTITY_LABELS = {
    tenant: "Tenant",
    building: "Asset",
    area: "Area",
    meter: "Meter",
    service: "Service",
    charge: "Charge",
    invoice: "Invoice",
};
function RemovalRequestsPage() {
    var _this = this;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, hooks_1.useAppSelector)(function (state) { return state.auth; }), clientId = _a.clientId, userId = _a.userId;
    var _b = (0, react_3.useState)("pending"), statusFilter = _b[0], setStatusFilter = _b[1];
    var _c = (0, react_3.useState)("all"), entityFilter = _c[0], setEntityFilter = _c[1];
    var _d = (0, react_3.useState)(null), decision = _d[0], setDecision = _d[1];
    var _e = (0, change_event_removal_request_1.useListRemovalRequestsQuery)({
        clientId: clientId,
        status: statusFilter === "all" ? undefined : statusFilter,
        entityType: entityFilter === "all" ? undefined : entityFilter,
    }, { skip: !clientId }), data = _e.data, isFetching = _e.isFetching;
    var requests = (0, react_3.useMemo)(function () { var _a, _b; return (_b = (_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.requests) !== null && _b !== void 0 ? _b : []; }, [data]);
    var _f = (0, change_event_removal_request_1.useApproveRemovalRequestMutation)(), approveRequest = _f[0], isApproving = _f[1].isLoading;
    var _g = (0, change_event_removal_request_1.useRejectRemovalRequestMutation)(), rejectRequest = _g[0], isRejecting = _g[1].isLoading;
    var isSubmitting = isApproving || isRejecting;
    var handleSubmitDecision = function () { return __awaiter(_this, void 0, void 0, function () {
        var trimmed, res, res, err_1, message;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!decision || !userId)
                        return [2 /*return*/];
                    trimmed = decision.reason.trim();
                    if (decision.mode === "reject" && !trimmed) {
                        (0, react_1.addToast)({ title: "Reason required", description: "Rejecting a request requires a reason.", color: "danger" });
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    if (!(decision.mode === "approve")) return [3 /*break*/, 3];
                    return [4 /*yield*/, approveRequest({ requestId: decision.request._id, decidedBy: userId, decisionReason: trimmed || undefined }).unwrap()];
                case 2:
                    res = _b.sent();
                    if (res.success)
                        (0, react_1.addToast)({ title: "Approved", description: "The change event has been removed.", color: "success" });
                    else
                        (0, react_1.addToast)({ title: "Approve failed", description: res.message || "Could not approve.", color: "danger" });
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, rejectRequest({ requestId: decision.request._id, decidedBy: userId, decisionReason: trimmed }).unwrap()];
                case 4:
                    res = _b.sent();
                    if (res.success)
                        (0, react_1.addToast)({ title: "Rejected", description: "The request has been declined.", color: "success" });
                    else
                        (0, react_1.addToast)({ title: "Reject failed", description: res.message || "Could not reject.", color: "danger" });
                    _b.label = 5;
                case 5: return [3 /*break*/, 8];
                case 6:
                    err_1 = _b.sent();
                    message = ((_a = err_1 === null || err_1 === void 0 ? void 0 : err_1.data) === null || _a === void 0 ? void 0 : _a.message) || "An error occurred.";
                    (0, react_1.addToast)({ title: "Action failed", description: message, color: "danger" });
                    return [3 /*break*/, 8];
                case 7:
                    setDecision(null);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var renderCell = function (req, columnKey) {
        var _a, _b;
        switch (columnKey) {
            case "entity": {
                var href_1 = entityLink(req.entityType, req.entityId);
                var label = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(_a = ENTITY_LABELS[req.entityType]) !== null && _a !== void 0 ? _a : req.entityType, " ", (0, jsx_runtime_1.jsx)("span", { className: "font-mono text-xs text-gray-500", children: req.entityId.slice(-8) })] }));
                if (!href_1) {
                    return (0, jsx_runtime_1.jsx)("span", { className: "text-left text-sm font-medium text-gray-700", children: label });
                }
                return ((0, jsx_runtime_1.jsx)(react_1.Button, { variant: "light", size: "sm", className: "h-auto min-w-0 justify-start p-0 text-sm font-medium text-primary hover:underline", onPress: function () { return navigate(href_1); }, children: label }));
            }
            case "event":
                return (0, jsx_runtime_1.jsx)("span", { className: "font-mono text-xs text-gray-600", children: req.eventId.slice(-12) });
            case "requestedBy":
                return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col", children: [(0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-800", children: userLabel(req.requestedByUser, req.requestedBy) }), (0, jsx_runtime_1.jsxs)("span", { className: "text-xs italic text-gray-500", children: ["\"", req.requestReason, "\""] })] }));
            case "submittedAt":
                return (0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-600", children: formatDateTime(req.createdAt) });
            case "status":
                return ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: STATUS_COLOR[req.status], children: req.status[0].toUpperCase() + req.status.slice(1) }));
            case "decision":
                if (req.status === "pending")
                    return (0, jsx_runtime_1.jsx)("span", { className: "text-xs text-gray-400", children: "\u2014" });
                return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col", children: [(0, jsx_runtime_1.jsxs)("span", { className: "text-xs text-gray-700", children: [formatDateTime(req.decidedAt), " \u00B7 by ", userLabel(req.decidedByUser, (_b = req.decidedBy) !== null && _b !== void 0 ? _b : "")] }), req.decisionReason && (0, jsx_runtime_1.jsxs)("span", { className: "text-xs italic text-gray-500", children: ["\"", req.decisionReason, "\""] })] }));
            case "actions":
                if (req.status !== "pending")
                    return null;
                return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-1", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", color: "success", variant: "flat", onPress: function () { return setDecision({ request: req, mode: "approve", reason: "" }); }, children: "Approve" }), (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", color: "danger", variant: "flat", onPress: function () { return setDecision({ request: req, mode: "reject", reason: "" }); }, children: "Reject" })] }));
            default:
                return null;
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-6", children: [(0, jsx_runtime_1.jsxs)("div", { className: "rounded-xl bg-white p-6 shadow-sm", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex items-start justify-between gap-4", children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-2xl font-semibold text-gray-900", children: "Removal Requests" }), (0, jsx_runtime_1.jsx)("p", { className: "mt-1 text-sm text-gray-500", children: "Review and action user-submitted requests to remove updates from history. Approving will soft-delete the underlying change event; rejecting preserves it and records your reason." })] }) }), (0, jsx_runtime_1.jsxs)("div", { className: "mt-4 flex flex-wrap items-end gap-4", children: [(0, jsx_runtime_1.jsx)(react_1.Select, { disableAnimation: true, label: "Status", size: "sm", variant: "bordered", className: "w-40", selectedKeys: [statusFilter], onSelectionChange: function (keys) {
                                    if (keys !== "all") {
                                        setStatusFilter(Array.from(keys)[0] || "pending");
                                    }
                                }, children: STATUS_OPTIONS.map(function (opt) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, { children: opt.label }, opt.key)); }) }), (0, jsx_runtime_1.jsx)(react_1.Select, { disableAnimation: true, label: "Entity", size: "sm", variant: "bordered", className: "w-48", selectedKeys: [entityFilter], onSelectionChange: function (keys) {
                                    if (keys !== "all") {
                                        setEntityFilter(Array.from(keys)[0] || "all");
                                    }
                                }, children: ENTITY_OPTIONS.map(function (opt) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, { children: opt.label }, opt.key)); }) }), (0, jsx_runtime_1.jsxs)("span", { className: "text-sm text-gray-500", children: [requests.length, " request", requests.length === 1 ? "" : "s"] }), isFetching && (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "sm" })] })] }), (0, jsx_runtime_1.jsx)("div", { className: "rounded-xl bg-white shadow-sm", children: (0, jsx_runtime_1.jsxs)(react_1.Table, { "aria-label": "Removal requests", classNames: {
                        wrapper: "min-h-[400px]",
                        th: "bg-gray-50 text-gray-600 font-semibold",
                        td: "py-4 align-top",
                    }, children: [(0, jsx_runtime_1.jsxs)(react_1.TableHeader, { children: [(0, jsx_runtime_1.jsx)(react_1.TableColumn, { children: "ENTITY" }, "entity"), (0, jsx_runtime_1.jsx)(react_1.TableColumn, { children: "EVENT" }, "event"), (0, jsx_runtime_1.jsx)(react_1.TableColumn, { children: "REQUESTED BY" }, "requestedBy"), (0, jsx_runtime_1.jsx)(react_1.TableColumn, { children: "SUBMITTED" }, "submittedAt"), (0, jsx_runtime_1.jsx)(react_1.TableColumn, { children: "STATUS" }, "status"), (0, jsx_runtime_1.jsx)(react_1.TableColumn, { children: "DECISION" }, "decision"), (0, jsx_runtime_1.jsx)(react_1.TableColumn, { children: "ACTIONS" }, "actions")] }), (0, jsx_runtime_1.jsx)(react_1.TableBody, { items: requests, emptyContent: isFetching ? " " : "No removal requests found for this filter.", isLoading: isFetching, loadingContent: (0, jsx_runtime_1.jsx)(react_1.Spinner, { label: "Loading requests..." }), children: function (item) { return (0, jsx_runtime_1.jsx)(react_1.TableRow, { children: function (columnKey) { return (0, jsx_runtime_1.jsx)(react_1.TableCell, { children: renderCell(item, columnKey) }); } }, item._id); } })] }) }), decision && ((0, jsx_runtime_1.jsx)("div", { className: "fixed inset-0 z-[80] flex items-center justify-center bg-black/40 p-4 backdrop-blur-sm", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex w-full max-w-lg flex-col gap-3 rounded-xl bg-white p-5 shadow-xl", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: decision.mode === "approve" ? "solar:check-circle-linear" : "solar:close-circle-linear", className: ["text-lg", decision.mode === "approve" ? "text-success" : "text-danger"].join(" ") }), (0, jsx_runtime_1.jsx)("h2", { className: "text-base font-semibold text-gray-800", children: decision.mode === "approve" ? "Approve removal request" : "Reject removal request" })] }), (0, jsx_runtime_1.jsx)("p", { className: "text-xs text-gray-500", children: decision.mode === "approve"
                                ? "Approving will soft-delete the underlying change event from history. The deletion is preserved in the immutable audit trail."
                                : "Rejecting preserves the change event and records your reasoning." }), (0, jsx_runtime_1.jsx)(react_1.Textarea, { label: (0, jsx_runtime_1.jsxs)("span", { className: "text-xs font-medium", children: [decision.mode === "approve" ? "Decision note (optional)" : "Decision reason", decision.mode === "reject" && (0, jsx_runtime_1.jsx)("span", { className: "text-danger", children: " *" })] }), value: decision.reason, onValueChange: function (v) { return setDecision(__assign(__assign({}, decision), { reason: v })); }, variant: "bordered", minRows: 2, maxRows: 4, placeholder: decision.mode === "approve" ? "Optional explanation." : "Why is this request being declined?" }), (0, jsx_runtime_1.jsxs)("div", { className: "flex justify-end gap-2 pt-2", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "light", onPress: function () { return setDecision(null); }, isDisabled: isSubmitting, children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_1.Button, { color: decision.mode === "approve" ? "success" : "danger", onPress: handleSubmitDecision, isLoading: isSubmitting, children: decision.mode === "approve" ? "Confirm Approval" : "Confirm Rejection" })] })] }) }))] }));
}
